import {
    CREATE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE,
    CREATE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST,
    CREATE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_ALL_OVER_PRINTING_DC_DETAILS,
    DELETE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE,
    DELETE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST,
    DELETE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_DETAILS_FAILURE,
    FETCH_ALL_OVER_PRINTING_DC_DETAILS_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS,
    ALL_OVER_PRINTING_DC_DETAILS_USERFORM_RESET,
    UPDATE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE,
    UPDATE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST,
    UPDATE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_FAILURE,
    FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_REQUEST,
    FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_SUCCESS,
    FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_FAILURE,
    FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_REQUEST,
    FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_SUCCESS,
    FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_FAILURE,
    FETCH_PRINTING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_PRINTING_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_PRINTING_DC_PREVIOUS_LIST_FAILURE,
    ALL_OVER_PRINTING_DC_PROGRAM_ID_SUCCESS,
    ALL_OVER_PRINTING_DC_PROGRAM_ID_REQUEST,
    ALL_OVER_PRINTING_DC_PROGRAM_ID_FAILURE,
    FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_REQUEST,
    FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_SUCCESS,
    FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_FAILURE,
    SHOW_PREVIOUS_LIST,

} from './printingDCDetails.actionsType';

export const ALL_OVER_PRINTING_DC_DETAILS = 'AllOverPrintingDcDetails';

let initialState = {
    loading: false,
    printingDCDetailsById: [],
    printingDCDetails: [],
    printingDCDetailsDcNo: [],
    grnNoByPrintingDcNo: [],
    printingDCDetailsProgram: [],
    previousList: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedPrintingDCDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    reprocessPrevList: [],
    showPrevious: true
};

export let allOverPrintingDCDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ALL_OVER_PRINTING_DC_DETAILS_REQUEST:
        case FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_REQUEST:
        case FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_REQUEST:
        case FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_REQUEST:
        case FETCH_ALL_OVER_PRINTING_DC_DETAILS_BY_ID_REQUEST:
        case CREATE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST:
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST:
        case UPDATE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST:
        case DELETE_ALL_OVER_PRINTING_DC_DETAILS_REQUEST:
        case FETCH_PRINTING_DC_PREVIOUS_LIST_REQUEST:
        case ALL_OVER_PRINTING_DC_PROGRAM_ID_REQUEST:
        case FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDCDetails: updatePayload
            };
        case FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDCDetailsProgram: updatePayload?.Program
            };
        case FETCH_ALL_OVER_PRINTING_DC_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDCDetailsById: updatePayload
            };
        case SHOW_PREVIOUS_LIST:
            return {
                ...state,
                loading: false,
                showPrevious: payload
            }
        case FETCH_PRINTING_DC_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload?.Program
            };
        case FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                grnNoByPrintingDcNo: updatePayload?.Inward
            };
        case ALL_OVER_PRINTING_DC_PROGRAM_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fldFkProgramId: updatePayload.fldFKProgram
            }
        case CREATE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDCDetailsDcNo: updatePayload?.PRD
            };
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedPrintingDCDetails: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedPrintingDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case DELETE_ALL_OVER_PRINTING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedPrintingDCDetails: {}
            };
        case FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                reprocessPrevList: updatePayload?.BED
            };
        case FETCH_ALL_OVER_PRINTING_DC_DETAILS_FAILURE:
        case FETCH_ALL_OVER_PRINTING_DC_DETAILS_PROGRAM_FAILURE:
        case FETCH_ALL_OVER_PRINTING_DC_DETAILS_DC_NO_FAILURE:
        case FETCH_GRN_NO_BY_ALL_OVER_PRINTING_DC_NO_FAILURE:
        case FETCH_SINGLE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE:
        case CREATE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE:
        case UPDATE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE:
        case DELETE_ALL_OVER_PRINTING_DC_DETAILS_FAILURE:
        case FETCH_PRINTING_DC_PREVIOUS_LIST_FAILURE:
        case ALL_OVER_PRINTING_DC_PROGRAM_ID_FAILURE:
        case FETCH_PRINTING_DC_REPROCESS_PREVIOUS_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ALL_OVER_PRINTING_DC_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case ALL_OVER_PRINTING_DC_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedPrintingDCDetails: {}
            };
        default:
            return state;
    }
};
